export default [
  'STONE_WOOL',
  'OTHER',
]

export const growingMediumGrodan = 'STONE_WOOL'
